module.exports = __webpack_public_path__ + "static/media/circle.5106def8.svg";